var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownActiveIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.734673 6.59297C0.777706 6.69534 0.850079 6.78269 0.942672 6.844C1.03526 6.90531 1.14393 6.93785 1.25499 6.9375L12.505 6.9375C12.616 6.93784 12.7247 6.90531 12.8173 6.844C12.9099 6.78269 12.9823 6.69534 13.0253 6.59297C13.0658 6.48907 13.0761 6.37582 13.055 6.26632C13.0338 6.15682 12.9821 6.05555 12.9058 5.97422L7.28077 0.349216C7.17325 0.245255 7.02954 0.18714 6.87999 0.18714C6.73043 0.18714 6.58672 0.245255 6.4792 0.349216L0.854205 5.97422C0.777896 6.05555 0.726173 6.15682 0.705021 6.26632C0.683867 6.37582 0.694148 6.48907 0.734673 6.59297Z",
    fill: "#00338D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownActiveIcon);
export default __webpack_public_path__ + "static/media/dropdown-active-icon.07b6e0a685170fe39d49fafabc2cce83.svg";
export { ForwardRef as ReactComponent };